import React from 'react'
import {useState, useEffect} from 'react'
import {MyButton1} from "../mybutton1/MyButton1"

import StatusContext from '../../../contexts/StatusContext';
import AuthContext from "../../../contexts/AuthContext";
import ClientContext from "../../../contexts/ClientContext";
import "./credits.css"
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {CardStripePaymentForm} from './CardStripePaymentForm'

import axios from 'axios';
import { config } from '../../../config';

// IMPORTANT:
// Make sure this variable actually exists in your .env file.
//
// For Create React App:
// REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_....
//
// For Vite it would be:
// import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
//
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

let price = 0;

export const Credits = () => {

  

  const[totalcredits, setCredits] = useState(0)
  const [hoveredIndex, setHoveredIndex] = useState(-1); // Default to -1 (no hover)

  const [showPayment, setShowPayment] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paystatus, setPayStatus] = useState(
      {
        message: "", 
        display: false
      }
    )

    let {
      changeLanguage,
      showcreditsdialog,
      setShowCreditsDialog,
      setIsLoading,
    } = React.useContext(StatusContext);

    let {
      currentUser,
      checkCurrentUser,
    } = React.useContext(AuthContext);

     let {
      addCredits
    } = React.useContext(ClientContext);
    
    
    useEffect(()=>{
     
      const getCredits = async () => {
            
        if (currentUser === null || currentUser.length === 0)
        {
            console.log("User is not logged in.")
            return;
        }

        let inputs ={
            user:currentUser,
         }
         setIsLoading(true);
        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/getcredits", {inputs},{
                withCredentials:true
            })
            //sessionStorage.setItem("AvailableCredits", res.data )
            setCredits(JSON.parse(res.data))
          
        }
        catch (err){
            console.log("Getting credits error:",err )
           
        }
        setIsLoading(false);
    }

    getCredits()
      
      if (sessionStorage.getItem("PaymentStatus"))
      {
        setPayStatus(JSON.parse(sessionStorage.getItem("PaymentStatus")))
        sessionStorage.removeItem("PaymentStatus")
      }
    },[currentUser, setIsLoading])

    const payments = [

      {
        paymenttext: changeLanguage('credits', 'paymenttext1'),
        taxtext: changeLanguage('credits', 'taxtext'),
        creditstext: changeLanguage('credits', 'creditstext1'),
        buttontext: changeLanguage('credits', 'buttontext1'),
        price: 7.99,
      },

      {
        paymenttext: changeLanguage('credits', 'paymenttext2'),
        taxtext: changeLanguage('credits', 'taxtext'),
        creditstext: changeLanguage('credits', 'creditstext2'),
        buttontext: changeLanguage('credits', 'buttontext2'),
        price: 12.99,
      },

    ]

     // --------------------------------------------------
  // CANCEL PAYMENT
  // --------------------------------------------------

  const handlePaymentCancel = (error) => {
    console.log(
      "handlePaymentCancel: Stripe payment failed", error
    );

 
    let text = error?.message ? '(' + error.message + ')' : '';

    setPayStatus({
      message: changeLanguage('credits', 'paymentfailed') + ' ' + text,
      display: true
    });

    setShowPayment(false);
    setClientSecret(null);
  };

  // --------------------------------------------------
  // PAYMENT SUCCESS
  // --------------------------------------------------

  const handlePaymentSuccess = () => {

    console.log(
      "handlePaymentSuccess:Stripe payment completed"
    );

    //Update credits after successful payment
    let credits = 0
    if (price === 7.99)
     credits = totalcredits + 100000
    else 
     credits = totalcredits + 200000

    setCredits(credits)

    setPayStatus({
    message: changeLanguage("credits", "paymentsuccessful"),
    display: true
    });

    setShowPayment(false);

    setClientSecret(null);

    if (price === 7.99)
     credits = 100000
    else 
     credits = 200000

    addCredits(credits)

  };

  const handleBuy = async (purchaseprice) => {
     
      console.log("handleBuy:");

        setPayStatus({
          message: "",
          display: false,
        })

       if (checkCurrentUser() === false)
      {
        let status = {
          message: changeLanguage('status', 'pleaselogin'), 
          display: true
        }
        setPayStatus(status)
          
        return;
      }
  
     

      let addition = purchaseprice === 7.99 ? 100000 : 200000
      if ((totalcredits + addition) > 400000)
      {
        let status = {
          message: changeLanguage('credits', 'creditlimit'), 
          display: true
        }
        setPayStatus(status)
        return
      }

       // ------------------------------------------------
      // Show payment area
      // ------------------------------------------------
  
      setPaymentLoading(true);
  
      setShowPayment(true);

      price = purchaseprice

      let formatedPrice = price.toFixed(2);
  
       try {
      
            // ------------------------------------------------
            // Create PaymentIntent on your SERVER
            // ------------------------------------------------
      
            const response = await fetch(
      
              config.url.API_URL +
              "/deda_ai_api/pay/create_payment_intent_buy_credits",
      
              {
                method: "POST",
      
                headers: {
                  "Content-Type": "application/json"
                },
      
              
                body: JSON.stringify({
                  user: currentUser,
                  credits: formatedPrice < 10 ? 100000 : 200000,
      
                  // TEMPORARY:
                  // You should eventually determine
                  // the price on the SERVER.
                  //payment: 5.6
                  payment: formatedPrice
                })
              }
            );
      
      
            const data = await response.json();
      
      
            console.log(
              "buycreditstintent response:",
              data
            );
      
      
            if (!response.ok) {
      
              throw new Error(
                data.message ||
                "Unable to create payment"
              );
            }
      
      
            if (!data.clientSecret) {
      
              throw new Error(
                "Server did not return clientSecret"
              );
            }
      
      
            // ------------------------------------------------
            // Stripe PaymentIntent client secret
            // ------------------------------------------------
      
            setClientSecret(
              data.clientSecret
            );
      
      
          } catch (error) {
      
            console.error(
              "Payment initialization error:",
              error
            );
      
            console.log("It is OK")
            setShowPayment(false);
            setClientSecret(null);
      
      
          } finally {
      
            setPaymentLoading(false);
      
          }
  
  
    }
  
    
    const handleClose = () => {

      let status = {
          message: "", 
          display: false
        }
      setPayStatus(status)
      
      setShowPayment(false);
      setClientSecret(null);
      setShowCreditsDialog(false);
      
    };

   
    const styles = {
      container: {
        alignItems: 'center', // Center vertically
     
        padding: '10px',
        marginBottom: '10px',
        width: '100%',
        border:'none',
     
        backgroundColor: (index) => (hoveredIndex === index ?  'lightblue' : 'rgb(240, 231, 212)'), // Change color based on hovered index
        transition: 'background-color 0.3s ease', // Optional transition for smooth effect
        },
    
        item: {
          
          alignItems: 'center', // Center vertically
          textAlign: 'center',
          color: 'maroon',
          borderRadius: '5px',
         
          padding: '3px',
          marginBottom: '10px',
          width: '100%',
          border:'none',
       
          backgroundColor: (index) => (hoveredIndex === index ? 'lightblue' : 'rgb(240, 231, 212)' ), // Change color based on hovered index
          transition: 'background-color 0.3s ease', // Optional transition for smooth effect
          },
      title: {
        display: 'flex',
        color: 'rgb(138, 57, 57)',
        fontSize: '26px',
        marginTop:'-25px',
        marginBottom: '-15px',
        justifyContent: 'center',
      },
      
      text: {
      
        color: 'rgb(138, 57, 57)',
        fontSize: '16px',
        fontWeight: '500',
        marginBottom:'15px',
        justifyContent: 'center',
        textAlign:'center',
      },
      savebutton: {
       
        justifyContent: 'center',
      },
      note: {
        color: 'rgb(138, 57, 57)',
        fontSize: '12px',
        fontWeight: '500',
        marginBottom:'15px',
        justifyContent: 'center',
        textAlign:'center',
      }
     
    }
    
  
  return (
    <React.Fragment>
    <Dialog
 
      open={showcreditsdialog}
      onClose={handleClose}
     
    >

    <DialogTitle></DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
       <CloseIcon />
      </IconButton>

      <DialogContent>
    
      <div style={{marginBottom: '-40px'}}>
        
      <h2 className="payasyougoTitle"  >{changeLanguage('credits', 'title')}</h2>
      <div className="getcreditsText">
        {changeLanguage('credits', 'text1')}
        <hr></hr>
      </div>

         
    </div>
    <br></br>

    {
                  Array.isArray(payments) &&
                    payments.map((item, index) => (
                      <div key = {index} 
                        style={{ ...styles.item, backgroundColor: styles.item.backgroundColor(index) }}
                        
                        onMouseEnter={() => setHoveredIndex(index)} // Set hover state to true
                        onMouseLeave={() => setHoveredIndex(-1)} // reset
                      >
                      <span style={{fontWeight:'500'}}>{payments[index].paymenttext}</span>
                      <br></br>
                    
                      <p style={{fontSize:'14px'}}>{payments[index].creditstext}</p>
                     
                      <MyButton1 text={payments[index].buttontext} stylename="buyCreditsButton" onClick = {() => {handleBuy(payments[index].price)}}/> 
                     
                      </div>
                  ))
}
                

                {
                  <div>
                    {/* ====================================== */}
                    {/* PAYMENT LOADING                         */}
                    {/* ====================================== */}
                     
                    {showPayment &&
                      //buyingItem === item &&
                      paymentLoading && (
                        <div
                          onClick={(e) =>
                          e.stopPropagation()
                          }
                     
                          style={{
                            padding: "15px",
                            marginTop: "10px",
                            backgroundColor: "#f5f5f5",
                            borderRadius: "8px"
                          }}
                          >
                     
                          Creating payment...
                     
                          </div>
                    )}
                     
                    {/* ====================================== */}
                    {/* STRIPE PAYMENT FORM                    */}
                    {/* ====================================== */}
                                   
                    {showPayment &&
                      //buyingItem === item &&
                      clientSecret && (
                      <div
                        onClick={(e) =>
                        e.stopPropagation()
                        }  
                        style={{
                          marginTop: "15px",
                          padding: "15px",
                          backgroundColor: "#f5f5f5",
                          borderRadius: "8px",
                          width: "100%",
                          boxSizing: "border-box"
                        }}
                        >
                                   
                        <Elements
                          stripe={stripePromise}
                          options={{
                            clientSecret: clientSecret,
                            appearance: {
                              theme: "stripe"
                            },
                        }}
                        >
                                   
                        <CardStripePaymentForm
                          clientSecret={clientSecret}
                          price={price}
                          onSuccess={
                            handlePaymentSuccess
                          }
                          onCancel={
                            handlePaymentCancel
                          }
                                    
                        />
                                   
                      </Elements>
                                   
                  </div>
                                   
                  )}
                </div>
                             
                }

           
             <>
              {
              (paystatus.display) &&
                <label className="creditsStatusText">{paystatus.message}</label>
              }       
              </>
          
              <div className="labelCreditsText">{changeLanguage('credits', 'text5')} {totalcredits.toLocaleString()} {changeLanguage('credits', 'text6')}</div>

          <div className="getcreditsText">
            {changeLanguage('credits', 'text7')}
          <br></br>
          </div>
       </DialogContent>
   
      </Dialog>

    </React.Fragment>
  )
}

export default Credits
